import { StyleSheet } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";

const style = () => {
  const { borderRadiusFull, borderWidth2, colorBorderInput, colorTextMedium, colorBgRose, colorText, space2, space12 } =
    theme();

  const styleSheet = StyleSheet.create({
    actionButtonSmall: {
      flex: 1,
    },
    actionButtons: {
      flexDirection: "row",
      width: "100%",
    },
    addToWishlistButton: {
      alignItems: "center",
      borderColor: colorBorderInput,
      borderRadius: borderRadiusFull,
      borderWidth: borderWidth2,
      height: space12,
      justifyContent: "center",
      marginLeft: space2,
      padding: space2,
      width: space12,
    },
    infoIcon: {
      marginRight: space2,
    },
    infoRow: {
      flexDirection: "row",
      justifyContent: "center",
      paddingBottom: space2,
    },
  });

  return {
    ...styleSheet,
    colorBgRose,
    colorText,
    colorTextMedium,
  };
};

export { style };
